import { Statistic as StatisticEnum } from '@repo/shared';
import { getRouteApi } from '@tanstack/react-router';

import TestEnvironment from '@/routes/(app)/(statistics)/(test-environment)/test-environment';

const route = getRouteApi('/app/statistics/$statistic');

const Statistic = () => {
  const { statistic } = route.useParams();

  if (statistic === StatisticEnum.TEST_ENVIRONMENT) {
    return <TestEnvironment />;
  }
};

export default Statistic;
